(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6383],{

/***/ 65988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ Accordion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var _components_elements_Spacer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var Accordion = function Accordion(_ref) {
  var accordionTitle = _ref.accordionTitle,
      children = _ref.children,
      contentsLength = _ref.contentsLength,
      _ref$isDefaultOpen = _ref.isDefaultOpen,
      isDefaultOpen = _ref$isDefaultOpen === void 0 ? false : _ref$isDefaultOpen;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isDefaultOpen),
      isExpand = _useState[0],
      setIsExpand = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      childHeight = _useState2[0],
      setChildHeight = _useState2[1];

  var childElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (childElement.current) {
      var _childElement$current;

      var height = (_childElement$current = childElement.current) === null || _childElement$current === void 0 ? void 0 : _childElement$current.clientHeight;
      setChildHeight(height);
    }
  }, []);

  var handleClick = function handleClick() {
    if (childElement.current) {
      setIsExpand(!isExpand);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(AccordionTitle, {
      onClick: handleClick,
      children: [contentsLength > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Icon, {
        isExpand: isExpand
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Title, {
        children: accordionTitle
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_elements_Spacer__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .L, {
      h: {
        sp: 10,
        pc: 18
      }
    }), contentsLength === 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(NoItemText, {
      children: "\u305F\u3060\u3044\u307E\u63B2\u8F09\u3059\u3079\u304D\u4E8B\u9805\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u3002"
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(AccordionItems, {
      isExpand: isExpand,
      childHeight: childHeight,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        ref: childElement,
        children: children
      })
    })]
  });
};
var AccordionTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Accordion__AccordionTitle",
  componentId: "sc-1afnqmj-0"
})(["display:flex;align-items:center;gap:10px;&:hover{cursor:pointer;> h4{color:", ";}}@media screen and (max-width:1047px){align-items:flex-start;gap:6px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.lightBlue */ .r.colors.lightBlue);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
  displayName: "Accordion__Title",
  componentId: "sc-1afnqmj-1"
})(["font-size:24px;font-weight:bold;color:", ";line-height:33.6px;@media screen and (max-width:1047px){font-size:18px;line-height:23.4px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var NoItemText = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Accordion__NoItemText",
  componentId: "sc-1afnqmj-2"
})(["font-size:16px;line-height:25.6px;color:", ";@media screen and (max-width:1047px){font-size:15px;line-height:24px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.textTitle */ .r.colors.textTitle);
var AccordionItems = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Accordion__AccordionItems",
  componentId: "sc-1afnqmj-3"
})(["height:", ";opacity:", ";transition:height 0.2s linear,opacity 0.5s ease-in;overflow:hidden;"], function (_ref2) {
  var isExpand = _ref2.isExpand,
      childHeight = _ref2.childHeight;
  return isExpand ? "".concat(childHeight, "px") : '0px';
}, function (_ref3) {
  var isExpand = _ref3.isExpand;
  return isExpand ? 1 : 0;
});
var Icon = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Accordion__Icon",
  componentId: "sc-1afnqmj-4"
})(["transition:all 0.25s ease;overflow:hidden;position:relative;padding-top:2px;padding-right:10px;width:40px;height:40px;&::before,&::after{content:'';display:inline-block;width:30px;height:4px;position:absolute;top:50%;background-image:url('/images/accordion.png');}&::after{transform:rotate(90deg);transition:transform 0.4s ease;}", " @media screen and (max-width:1047px){padding-top:7px;padding-right:16px;width:16px;height:23px;&::before,&::after{width:16px;height:2.13px;}}"], function (_ref4) {
  var isExpand = _ref4.isExpand;
  return isExpand ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["&::after{transform:rotate(0);}"]) : '';
});

/***/ }),

/***/ 97071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ PDFIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/pdf.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 24"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1777"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1540",
    d: "M5.963 5.234V.291L.278 5.976h4.943c.534 0 .742-.208.742-.742Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1541",
    d: "M8.819 11.945a8.259 8.259 0 0 0 .414-1.759c.207-1.008-.052-1.629-.594-1.55s-.672.7-.62 1.344a5.342 5.342 0 0 0 .594 1.784s.1.258.206.181Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1542",
    d: "M6.339 17.118a5.839 5.839 0 0 0-2.041 1.086c-.7.673-.648 1.267-.336 1.473s1.189-.414 1.732-1.06a5.145 5.145 0 0 0 .9-1.4c.004-.099-.047-.177-.255-.099Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1543",
    d: "M8.214 16.028c.515-.206 2.377-.621 2.377-.621s-1.214-1.447-1.37-1.732c0 .001-.724 1.888-1.007 2.353Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1544",
    d: "M17.051 0H6.97v5.864a1.171 1.171 0 0 1-1.164 1.174H0v16a.955.955 0 0 0 .949.957h16.1a.954.954 0 0 0 .949-.957V.956A.954.954 0 0 0 17.051 0Zm-3.106 17.849a7.087 7.087 0 0 1-2.917-1.886.23.23 0 0 0-.069-.015c-.15 0-1.82.485-3.088.848-1.854 3.341-3.7 4.294-4.567 3.189-.456-.582-.28-1.955 1.914-2.984a14.164 14.164 0 0 1 1.77-.668 31.5 31.5 0 0 0 1.573-3.579 10.185 10.185 0 0 1-1.072-2.772c-.1-1.081.357-2.059 1.276-2.059 1.171 0 2.04 1.132.668 5.111a12.589 12.589 0 0 0 1.673 2.246 13.561 13.561 0 0 1 2.784-.261c1.651.1 1.994.877 2.045 1.469a1.6 1.6 0 0 1-1.99 1.361Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1545",
    d: "M13.761 15.555a6.219 6.219 0 0 0-2.069.258 6.871 6.871 0 0 0 2.093 1.035c.777.1 1.062-.232 1.062-.568s-.284-.673-1.086-.725Z"
  }))));
};
/* harmony default export */ var pdf = (SvgPdf);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PDFIcon = function PDFIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'regular' : _ref$size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread(_objectSpread({}, props), {}, {
    "data-size": size
  }));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(pdf).withConfig({
  displayName: "PDF__StyledIcon",
  componentId: "sc-18bayee-0"
})(["transition:fill 0.3s ease;fill:", ";&[data-size='regular']{width:18px;height:24px;}&[data-size='small']{width:12px;height:28px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);

/***/ }),

/***/ 24604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PDFItem; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16645);
/* harmony import */ var _components_elements_Icon_PDF__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97071);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var PDFItem = function PDFItem(_ref) {
  var date = _ref.date,
      fileName = _ref.fileName,
      filePath = _ref.filePath;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledLink, {
    href: filePath,
    target: "_blank",
    rel: "noreferrer noopener",
    children: [date && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Time, {
      dateTime: date,
      children: (0,_utils_date__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(date, 'yyyy/MM/dd')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Icon, {
      size: "small"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Name, {
      children: fileName
    })]
  });
};
var Time = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].time.withConfig */ .ZP.time.withConfig({
  displayName: "PDFItem__Time",
  componentId: "sc-12039hs-0"
})(["font-weight:700;line-height:1.6;"]);
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "PDFItem__StyledLink",
  componentId: "sc-12039hs-1"
})(["transition:color 0.3s ease;display:flex;align-items:center;gap:10px;padding-top:18px;padding-bottom:20px;width:100%;&:hover{> span{color:", ";text-decoration:underline;}> svg{fill:", ";}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.lightBlue */ .r.colors.lightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.lightBlue */ .r.colors.lightBlue);
var Name = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "PDFItem__Name",
  componentId: "sc-12039hs-2"
})(["line-height:1.6;"]);
var Icon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_components_elements_Icon_PDF__WEBPACK_IMPORTED_MODULE_1__/* .PDFIcon */ .H).withConfig({
  displayName: "PDFItem__Icon",
  componentId: "sc-12039hs-3"
})(["flex-shrink:0;"]);

/***/ }),

/***/ 16653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ PDFList; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var _PDFItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24604);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PDFList = function PDFList(_ref) {
  var pdfList = _ref.pdfList;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ul", {
    children: pdfList.map(function (pdf) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Item, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_PDFItem__WEBPACK_IMPORTED_MODULE_2__/* .PDFItem */ .G, _objectSpread({}, pdf))
      }, pdf.id);
    })
  });
};
var Item = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "PDFList__Item",
  componentId: "sc-mppgtj-0"
})(["display:flex;align-items:center;:not(:last-child){border-bottom:1px solid ", ";}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue);

/***/ }),

/***/ 94042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ midtermplan; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/elements/Accordion/index.tsx
var Accordion = __webpack_require__(65988);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Ir/index.tsx
var Ir = __webpack_require__(87661);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(45775);
// EXTERNAL MODULE: ./src/components/layouts/Ir/PDFList.tsx
var PDFList = __webpack_require__(16653);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Library/MidTermPlan/index.tsx












var midTermPlanDocument = {
  id: '20260212-a15f286d',
  fileName: '中期経営計画(2027年6月期～2029年6月期)　2026/02/12 公表',
  filePath: 'https://pdf.irpocket.com/C141A/xoA3/IjHJ/JWlA/RxC9.pdf'
};
var midTermPlanPdfGroups = [{
  accordionTitle: '2027年6月期～2029年6月期',
  accordionItems: [midTermPlanDocument],
  isDefaultOpen: true
}];
var midTermPlanDescription = '当社は、2027年６月期から2029年６月期を最終年度とする３ヵ年の中期経営計画を策定いたしました。\n\n' + '当中期経営計画においては、西友のPMIを着実に推進し、シナジー創出を軸としたキャッシュ創出力の向上によって財務健全性を高めるとともに、 次世代フォーマットの成功モデルの確立など、2030年６月期以降の更なる成長に向けた事業基盤を構築してまいります。';
var MidTermPlan = function MidTermPlan() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      titleText: "Medium-Term Management Plan",
      subTitleText: "\u4E2D\u671F\u7D4C\u55B6\u8A08\u753B"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PlanImage, {
      src: "/images/ir-library-medium-term-plan.jpg",
      alt: "",
      width: "2020",
      height: "1120"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PlanDescription, {
      children: midTermPlanDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionArea, {
      children: midTermPlanPdfGroups.map(function (value, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* Accordion */.U, {
            accordionTitle: value.accordionTitle,
            contentsLength: value.accordionItems.length,
            isDefaultOpen: value.isDefaultOpen,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(PDFList/* PDFList */.T, {
              pdfList: value.accordionItems
            })
          })
        }, "".concat(index).concat(value.accordionTitle));
      })
    })]
  });
};

MidTermPlan.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '株主・投資家向け情報',
    path: '/ir'
  }, {
    name: '経営方針',
    path: '/ir/library/'
  }, {
    name: '中期経営計画',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u4E2D\u671F\u7D4C\u55B6\u8A08\u753B",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u30B0\u30EB\u30FC\u30D7\u306E\u4E2D\u671F\u7D4C\u55B6\u8A08\u753B\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'ir/library/midtermplan/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};

var AccordionArea = (0,styled_components_browser_esm/* default */.ZP)(Paragraph/* Paragraph */.n).attrs({
  as: 'section'
}).withConfig({
  displayName: "MidTermPlan__AccordionArea",
  componentId: "sc-18czqqb-0"
})(["display:flex;flex-direction:column;gap:50px;width:100%;"]);
var PlanImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "MidTermPlan__PlanImage",
  componentId: "sc-18czqqb-1"
})(["display:block;width:100%;max-width:682px;height:auto;margin:30px auto 0;"]);
var PlanDescription = (0,styled_components_browser_esm/* default */.ZP)(Paragraph/* Paragraph */.n).withConfig({
  displayName: "MidTermPlan__PlanDescription",
  componentId: "sc-18czqqb-2"
})(["width:100%;margin:24px 0 0;color:#333;letter-spacing:0;white-space:pre-line;"]);
;// CONCATENATED MODULE: ./src/pages/ir/library/midtermplan.tsx

/* harmony default export */ var midtermplan = (MidTermPlan);

/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ isEqualYear; },
/* harmony export */   "dG": function() { return /* binding */ isEqualMonth; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72167);

var formatDate = function formatDate(date, formatType) {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), formatType);
  } catch (e) {
    return date;
  }
};
var isEqualYear = function isEqualYear(date, year) {
  return formatDate(date, 'yyyy') === year;
};
var isEqualMonth = function isEqualMonth(date, month) {
  return formatDate(date, 'M') === month;
};

/***/ }),

/***/ 29870:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/library/midtermplan",
      function () {
        return __webpack_require__(94042);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,2167,5548,4535,9774,2888,179], function() { return __webpack_exec__(29870); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);